import Resource, { ResourceApi } from '../../resource/Resource';
import { INSTITUTION_RESOURCE } from '../resourceNames';

import {
  SET_INSTITUTIONS,
  INSTITUTION_FEATURED_FETCH_START,
  INSTITUTION_FEATURED_FETCH_SUCCESS,
  INSTITUTION_FEATURED_FETCH_FAILURE,
  FETCH_INSTITUTION_ROLES_START,
  FETCH_INSTITUTION_ROLES_SUCCESS,
} from './actions';
import {
  INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_SUCCESS,
  INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_START,
  INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_FAILURE,
  INSTITUTION_ADMIN_UI_REMOVE_COURSE_START,
  INSTITUTION_ADMIN_UI_REMOVE_COURSE_SUCCESS,
  INSTITUTION_ADMIN_UI_REMOVE_COURSE_FAILURE,
} from '../InstitutionAdminUI/actions';

export function setInstitutions(institutions) {
  return {
    type: SET_INSTITUTIONS,
    institutions,
  };
}

export const retrieveInstitutions = (
  initArgsList,
  argName = 'path',
  resource = Resource
) => (dispatch) =>
  resource
    .lookup(INSTITUTION_RESOURCE, 'resources', {
      argName,
      initArgsList,
      ignoreMissing: true,
    })
    .then((institutions) => {
      dispatch(setInstitutions(Object.values(institutions)));
      const lcInstitutions = Object.keys(institutions).reduce(
        (updated, key) => {
          updated[key.toLowerCase()] = institutions[key]; // eslint-disable-line no-param-reassign
          return updated;
        },
        {}
      );
      return lcInstitutions;
    });

export function getFeaturableInstitutions() {
  return (dispatch) => {
    Resource.lookup(INSTITUTION_RESOURCE, 'getFeaturableInstitutions', {}).then(
      (institutions) => {
        dispatch(setInstitutions(Object.values(institutions)));
      }
    );
  };
}

export function getFeaturedInstitutions() {
  return (dispatch) => {
    Resource.lookup(INSTITUTION_RESOURCE, 'getFeaturedInstitutions', {}).then(
      (institutions) => {
        dispatch(setInstitutions(Object.values(institutions)));
      }
    );
  };
}

export function getAllInstitutions() {
  return (dispatch) => {
    return Resource.lookup(INSTITUTION_RESOURCE, 'getInstitutions', {}).then(
      (institutions) => {
        dispatch(setInstitutions(Object.values(institutions)));
      }
    );
  };
}

export function setFeatured(institutionPath, featured) {
  return (dispatch) => {
    Resource.update(INSTITUTION_RESOURCE, institutionPath, 'setFeatured', {
      featured,
    }).then((institution) => {
      dispatch(setInstitutions([institution]));
    });
  };
}

export function getInstitutionPortfolio() {
  return (dispatch) => {
    Resource.lookup(INSTITUTION_RESOURCE, 'getInstitutionPortfolio', {}).then(
      (institutions) => {
        dispatch(setInstitutions(Object.values(institutions)));
      }
    );
  };
}

export function setHomeFeatured(institutionPath, homeFeatured) {
  return (dispatch) => {
    Resource.update(INSTITUTION_RESOURCE, institutionPath, 'setHomeFeatured', {
      homeFeatured,
    }).then((institution) => {
      dispatch(setInstitutions([institution]));
    });
  };
}

export function setPortfolioIsAllowed(institutionPath, isAllowed) {
  return (dispatch) => {
    Resource.update(
      INSTITUTION_RESOURCE,
      institutionPath,
      'setPortfolioIsAllowed',
      {
        portfolioAllowed: isAllowed,
      }
    ).then((institution) => {
      dispatch(setInstitutions([institution]));
    });
  };
}

export function getInstitutionUsage(institutionPath) {
  return (dispatch) => {
    dispatch({
      type: INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_START,
      institutionPath,
    });
    Resource.read(
      INSTITUTION_RESOURCE,
      institutionPath,
      'activeUserCounts'
    ).then(
      (activeUserCountsData) => {
        dispatch({
          type: INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_SUCCESS,
          institutionPath,
          data: activeUserCountsData,
        });
      },
      (error) => {
        dispatch({
          type: INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_FAILURE,
          institutionPath,
          error,
        });
      }
    );
  };
}

export const fetchInstitutionRoles = () => {
  return (dispatch) => {
    dispatch({
      type: FETCH_INSTITUTION_ROLES_START,
    });
    Resource.lookup(INSTITUTION_RESOURCE, 'getInstitutionRolesForUser').then(
      (institutionRoles) => {
        dispatch({
          type: FETCH_INSTITUTION_ROLES_SUCCESS,
          institutionRoles,
        });
      }
    );
  };
};

export function removeCourseFromInstitution(institutionPath, coursePath) {
  const defaultErrorMessage =
    'There was a problem removing a course for this institution';

  return (dispatch) => {
    dispatch({
      type: INSTITUTION_ADMIN_UI_REMOVE_COURSE_START,
      institutionPath,
    });

    return ResourceApi.update(
      INSTITUTION_RESOURCE,
      institutionPath,
      'removeCourse',
      {
        coursePath,
      }
    ).then(
      (result) => {
        if (!result.success) {
          const errorMessage = result.error
            ? result.error
            : defaultErrorMessage;
          dispatch({
            type: INSTITUTION_ADMIN_UI_REMOVE_COURSE_FAILURE,
            institutionPath,
            error: errorMessage,
          });
        } else {
          dispatch({
            type: INSTITUTION_ADMIN_UI_REMOVE_COURSE_SUCCESS,
            institutionPath,
          });
        }
        return result;
      },
      (error) => {
        dispatch({
          type: INSTITUTION_ADMIN_UI_REMOVE_COURSE_FAILURE,
          institutionPath,
          error,
        });
      }
    );
  };
}

// ================== NATIVE
export function fetchFeaturedInstitution(params) {
  return (dispatch) => {
    const dispatchObjects = {
      start: INSTITUTION_FEATURED_FETCH_START,
      success: INSTITUTION_FEATURED_FETCH_SUCCESS,
      error: INSTITUTION_FEATURED_FETCH_FAILURE,
    };
    dispatch({ type: dispatchObjects.start });
    Resource.lookup(INSTITUTION_RESOURCE, 'getFeaturedInstitutions', params)
      .then((data) => {
        dispatch({
          type: dispatchObjects.success,
          institutions: data,
        });
      })
      .catch(() => {
        dispatch({ type: dispatchObjects.error });
      });
  };
}
